import { es_policies } from './es_policies';

export const es = {
  ...es_policies,
  nav: {
    offer: "Para quién",
    solutions: "Soluciones",
    cases: "Casos de estudio",
    process: "Proceso",
    pricing: "Precios",
    company: "Empresa",
    about: "Sobre nosotros",
    team: "Equipo",
    approach: "Nuestro enfoque",
    faq: "Preguntas",
    contact: "Contacto",
    comparison: "Comparación",
    cta: "Iniciar proyecto"
  },
  hero: {
    badge: "Oferta limitada",
    spotsLeft: "plazas este mes",
    headline: "Sitio web profesional para negocios",
    headline2: "Desde €500",
    subheadline: "Lanzamiento: hasta 1 semana",
    price: "€500 setup + €50/mes soporte (requerido)",
    feature1: "€500 — Setup",
    feature2: "Desde 1 semana",
    feature3: "€50/mes — Soporte requerido",
    trust1: "200+ proyectos",
    trust2: "15+ años experiencia",
    trust3: "Garantía de devolución",
    cta: "Empezar",
    ctaSecondary: "Hacer una pregunta"
  },
  value: {
    title: "Por qué los negocios inteligentes nos eligen",
    subtitle: "Otros cobran €5,000+, nosotros damos lo mismo por menos",
    speed: {
      title: "Velocidad relámpago",
      description: "Tu web lista en hasta 1 semana. Plazos reales."
    },
    quality: {
      title: "Ingenieros senior",
      description: "15+ años de experiencia. Código limpio que funciona."
    },
    support: {
      title: "Soporte humano",
      description: "Acceso directo al desarrollador. Sin chatbots."
    },
    price: {
      title: "Precios transparentes",
      description: "€500 + €50/mes. Eso es todo. Sin costes ocultos."
    }
  },
  comparison: {
    title: "La verdad sobre los precios del desarrollo web",
    subtitle: "Las agencias no quieren que sepas esto",
    traditional: {
      title: "Agencia típica",
      items: [
        "€3,000 - €15,000 precio medio",
        "3-6 meses de desarrollo",
        "Juniors trabajando en tu proyecto",
        "¿Soporte? ¿Qué soporte?",
        "Costes ocultos por todas partes"
      ]
    },
    dathent: {
      title: "El método Dathent",
      items: [
        "€500 — sí, realmente €500",
        "Hasta 1 semana lanzamiento",
        "Solo ingenieros senior",
        "12 meses de soporte real",
        "Lo que ves es lo que pagas"
      ]
    }
  },
  offer: {
    title: "¿Por qué tan barato?",
    subtitle: "La respuesta honesta",
    description: "Estamos construyendo nuestro portfolio en el mercado UE. En lugar de €10,000 en publicidad, invertimos en TI. Tú consigues un trato increíble, nosotros un caso y referencias.",
    highlight: "El precio de €500 no durará. Una vez alcancemos el objetivo, volvemos a €1,500+."
  },
  whatYouGet: {
    title: "Qué incluye",
    items: [
      {
        title: "Aplicación React personalizada",
        description: "Desde cero. Sin plantillas. Sin WordPress. Ingeniería real."
      },
      {
        title: "Diseño Mobile-First",
        description: "60% de visitantes son móviles. Hacemos que conviertan."
      },
      {
        title: "Optimización Google",
        description: "SEO desde el día uno. Aparece cuando te buscan."
      },
      {
        title: "Velocidad extrema",
        description: "Carga en menos de 2 segundos. Cada segundo cuesta dinero."
      },
      {
        title: "Propiedad total",
        description: "Todo el código es tuyo. Sin ataduras. Cambia de hosting cuando quieras."
      },
      {
        title: "Soporte de lanzamiento",
        description: "Hosting, dominio, lanzamiento — todo en nosotros. Solo mira."
      }
    ]
  },
  subscription: {
    title: "Tu equipo tech personal",
    badge: "Requerido con €500",
    subtitle: "Como tener un CTO en nómina",
    description: "Esto no es un 'plan de mantenimiento'. Tienes acceso directo a un desarrollador senior que conoce tu proyecto al dedillo.",
    price: "€50",
    period: "/mes",
    commitment: "12 meses",
    normalPrice: "Valor €150+/mes",
    features: [
      "Monitorización 24/7",
      "Actualizaciones de seguridad",
      "1.5 horas de cambios/mes",
      "Respuesta prioritaria",
      "Informes mensuales",
      "Acceso directo al desarrollador"
    ]
  },
  process: {
    title: "De cero a lanzamiento en 7 pasos",
    subtitle: "Un flujo de trabajo simple que realmente funciona",
    steps: [
      {
        title: "Cliente paga y realiza pedido",
        description: "Pago seguro. Tu proyecto está oficialmente iniciado."
      },
      {
        title: "Manager contacta y recopila datos",
        description: "Nos ponemos en contacto para recopilar todos los detalles necesarios sobre tu negocio."
      },
      {
        title: "Desarrollamos estrategia del sitio",
        description: "Creamos una estrategia integral y estructura para tu sitio."
      },
      {
        title: "Aprobar estrategia/estructura",
        description: "Revisas y apruebas el plan antes de que comencemos a construir."
      },
      {
        title: "Crear el sitio web",
        description: "Nuestro equipo construye tu sitio con código de nivel de producción."
      },
      {
        title: "Mostrar, recopilar feedback",
        description: "Presentamos el sitio web y recopilamos tus solicitudes de revisión."
      },
      {
        title: "Implementar cambios y publicar",
        description: "Hacemos los ajustes finales y lanzamos tu sitio web en vivo."
      }
    ]
  },
  pricing: {
    title: "Precios simples y honestos",
    subtitle: "No necesitas calculadora",
    supportRequired: "Soporte requerido",
    alternativeLabel: "Sin suscripción",
    alternativeTitle: "Desarrollo único",
    alternativePrice: "€1,500 pago único",
    alternativeOneTime: "pago único",
    alternativeNote: "Pago completo por adelantado, sin compromiso mensual",
    alternativeIncludes: "Qué incluye",
    alternativeFeatures: [
      "Sitio web React.js personalizado",
      "Diseño responsive móvil",
      "Optimización SEO",
      "Propiedad completa del código",
      "Configuración de hosting y despliegue",
      "Sin soporte continuo"
    ],
    alternativeFootnote: "Después de la entrega, las actualizaciones y el mantenimiento corren por tu cuenta. Elige esto solo si tienes recursos técnicos.",
    alternativeCta: "Ordenar sin suscripción",
    withoutSubscription: "Sin soporte continuo",
    withoutSubscriptionNote: "Manejas las actualizaciones tú mismo",
    withPremiumSubscription: "Con soporte premium",
    premiumSubscriptionNote: "30 días gratis, luego €150/mes",
    recommended: "Recomendado",
    orderNoSupport: "Ordenar €1.500",
    orderWithSupport: "Ordenar €1.500 + €150/mes",
    limitedSpots: "Plazas limitadas",
    startBuildingToday: "Comienza a construir tu web hoy",
    securePayment: "Pago seguro",
    moneyBackGuarantee: "Garantía de devolución",
    after1stMonth: "después del 1er mes",
    trustedByClients: "Confiado por 200+ clientes",
    package: {
      title: "Paquete web completo",
      description: "Todo para dominar online",
      oneTime: "Configuración web",
      monthly: "Soporte (requerido)",
      total: "Total primer mes",
      note: "€500 setup solo está disponible con suscripción obligatoria de €50/mes. La cancelación requiere pagar €1.000 de diferencia.",
      features: [
        "Aplicación React.js personalizada",
        "Diseño responsive móvil",
        "Optimización SEO",
        "Soporte técnico",
        "Propiedad del código",
        "Configuración hosting"
      ],
      cta: "Empezar ahora"
    }
  },
  company: {
    title: "Quiénes somos",
    description: "Dathent es un equipo de ingenieros experimentados. 15+ años construyendo apps para startups y corporaciones. Ahora hacemos el desarrollo premium accesible.",
    acceptingProjects: "Actualmente aceptando proyectos",
    stats: {
      years: "15+",
      yearsLabel: "Años experiencia",
      projects: "200+",
      projectsLabel: "Proyectos",
      clients: "98%",
      clientsLabel: "Satisfechos"
    }
  },
  contact: {
    title: "¿Listo para transformar tu negocio?",
    subtitle: "Elige el camino más rápido a tu nueva web",
    brief: {
      title: "Ordenar ahora",
      description: "No pierdas tiempo - este precio no durará para siempre, estas son las mejores condiciones del mercado.",
      cta: "Ordenar"
    },
    simple: {
      title: "¿Pregunta rápida?",
      description: "¿No estás seguro? No hay problema. Escríbenos. Sin presión.",
      cta: "Contactar"
    }
  },
  forms: {
    brief: {
      title: "Solicitar sitio web",
      step1Title: "Información de contacto",
      step2Title: "Detalles del proyecto",
      step3Title: "Resumen del pedido",
      progressStep1: "Contacto",
      progressStep2: "Proyecto",
      progressStep3: "Resumen",
      name: "Tu nombre",
      email: "Dirección de email",
      phone: "Teléfono",
      company: "Nombre de empresa (opcional)",
      addDetails: "Añadir empresa (opcional)",
      isBusinessPayment: "Pago empresarial (factura)",
      companyDetails: "Datos de la empresa",
      companyName: "Nombre de la empresa",
      vatNumber: "Número de IVA/CIF",
      companyAddress: "Dirección de la empresa",
      companyCity: "Ciudad",
      companyPostalCode: "Código postal",
      companyCountry: "País",
      taxInfo: "Cálculo de impuestos",
      taxAutomatic: "El IVA se calculará automáticamente según la ubicación de tu empresa durante el pago.",
      plusTax: "+ impuestos aplicables",
      projectType: "Tipo de proyecto",
      projectTypes: {
        landing: "Landing page",
        corporate: "Web corporativa",
        ecommerce: "E-commerce",
        webapp: "Aplicación web",
        other: "Otro"
      },
      description: "Describe tu proyecto",
      budget: "Rango de presupuesto",
      budgets: {
        basic: "€500 - €500",
        standard: "€500 - €1,000",
        premium: "€1,000+"
      },
      timeline: "¿Cuándo lo necesitas?",
      timelines: {
        urgent: "Urgente (hasta 1 semana)",
        normal: "Normal (desde 1 semana)",
        flexible: "Flexible"
      },
      hasDesign: "Ya tengo contenido/materiales",
      additionalInfo: "¿Algo más que debamos saber?",
      summarySetup: "Configuración del sitio web",
      summarySupport: "Suscripción de soporte",
      summaryMonthlyCost: "€50/mes (comienza después del primer mes)",
      summaryToday: "Hoy pagas",
      summaryNote: "El manager te contactará después del pago para recopilar detalles y comenzar",
      securePayment: "Pago seguro con Stripe",
      btnBack: "Atrás",
      btnContinue: "Continuar",
      btnPay: "Continuar al pago",
      submit: "Enviar brief",
      submitWithPayment: "Continuar al pago",
      legalAgreement: {
        title: "Acuerdo Legal",
        checkboxClickToView: "Haga clic para ver y aceptar los Términos de Servicio y el Acuerdo de Suscripción",
        checkboxAccepted: "He leído y acepto los Términos de Servicio y el Acuerdo de Suscripción",
        mustReadNotice: "Debe leer el acuerdo completo antes de continuar",
        scrollNotice: "⬇ Por favor, desplácese hasta el final para aceptar ⬇",
        closeButton: "Cerrar",
        acceptButton: "Aceptar y Continuar"
      }
    },
    contact: {
      title: "Contacto rápido",
      name: "Tu nombre",
      email: "Email",      phone: "Teléfono",      message: "Mensaje",
      submit: "Enviar"
    },
    success: "¡Recibido! Te respondemos en 24 horas.",
    error: "¡Ups! Algo salió mal. Inténtalo de nuevo.",
    briefSaved: "¡Gracias! Hemos recibido tu solicitud. Nos pondremos en contacto contigo en breve."
  },
  whoBenefits: {
    title: "¿Para quién es esto?",
    subtitle: "Solución perfecta para negocios listos para crecer online",
    examples: "Perfecto para",
    note: "¿No estás seguro si esto se ajusta a tu negocio? Contáctanos para una consulta rápida.",
    items: {
      smallBusiness: {
        title: "Pequeñas empresas",
        description: "Tiendas locales, servicios y negocios que necesitan presencia online profesional sin costes empresariales.",
        examples: [
          "Tiendas minoristas",
          "Restaurantes y cafés",
          "Salones de belleza"
        ]
      },
      localServices: {
        title: "Servicios locales",
        description: "Proveedores de servicios que necesitan atraer clientes locales y mostrar su experiencia online.",
        examples: [
          "Servicios de reparación",
          "Consultorios médicos",
          "Bufetes de abogados"
        ]
      },
      onlineServices: {
        title: "Servicios online",
        description: "Negocios digitales que operan remotamente y necesitan una plataforma profesional para convertir visitantes.",
        examples: [
          "Consultores",
          "Coaches",
          "Agencias digitales"
        ]
      },
      startups: {
        title: "Startups",
        description: "Empresas en etapa temprana que necesitan validar su idea rápidamente sin gastar en desarrollo costoso.",
        examples: [
          "Productos SaaS",
          "Apps móviles",
          "Nuevos proyectos"
        ]
      }
    }
  },
  faq: {
    badge: 'Preguntas',
    title: 'Preguntas frecuentes',
    subtitle: 'Todo lo que necesita saber sobre nuestro servicio',
    stillQuestions: '¿Todavía tiene preguntas?',
    contactUs: 'Estamos aquí para ayudar. No dude en contactarnos.',
    contactButton: 'Contactar',
    
    items: {
      whyCheap: {
        question: '¿Por qué tan económico?',
        answer: 'Estamos construyendo nuestro portfolio en el mercado UE. En lugar de €10,000 en publicidad, invertimos en TI. Tú consigues un trato increíble, nosotros un caso y referencias.'
      },
      supportRequired: {
        question: '¿Es obligatorio el soporte continuo?',
        answer: 'No, puede elegir la opción de pago único de €1,500 sin suscripción. Sin embargo, con la opción €500 + €50/mes, obtiene no solo un sitio web, sino también actualizaciones continuas, seguridad, copias de seguridad y soporte técnico.'
      },
      whenSubscription: {
        question: '¿Cuándo comienza la suscripción?',
        answer: 'La suscripción comienza solo después de que el sitio web se entregue completamente y usted lo apruebe. Paga €500 por adelantado para el desarrollo, y el primer pago de €50/mes vence solo después de que el sitio esté en vivo.'
      },
      canCancel: {
        question: '¿Puedo cancelar la suscripción?',
        answer: 'No, no puede simplemente cancelar. El precio de configuración de €500 es una oferta promocional con suscripción obligatoria. Si desea detener la suscripción, debe pagar la diferencia inmediatamente (€1.000 por un año), o elija nuestra opción de €1.500 de pago único sin suscripción desde el principio.'
      },
      whatNeeded: {
        question: '¿Qué necesitan de mí?',
        answer: 'Necesitamos su logo (o podemos diseñar uno), contenido de texto para las páginas, fotos de sus productos o servicios y los colores de su marca. Si no tiene todo listo, podemos ayudar a preparar el contenido por una tarifa adicional.'
      },
      howLong: {
        question: '¿Cuánto tiempo toma?',
        answer: 'Un sitio web estándar toma hasta 1 semana - sin contar el tiempo que el cliente piensa sobre las revisiones después de la primera versión del sitio.'
      },
      afterDelivery: {
        question: '¿Qué sucede después de la entrega?',
        answer: 'Después del lanzamiento, su sitio está completamente operativo. Con la suscripción, manejamos todos los aspectos técnicos: alojamiento, certificados SSL, copias de seguridad, actualizaciones de seguridad y cualquier corrección necesaria.'
      },
      ownership: {
        question: '¿Soy dueño del sitio web?',
        answer: '¡Sí, absolutamente! Usted posee el 100% del sitio web, el dominio y todo el contenido. Incluso si cancela la suscripción, el sitio web sigue siendo suyo. Podemos proporcionar todos los archivos fuente si desea moverlo a otro proveedor de hosting.'
      }
    }
  },
  serviceInfo: {
    badge: 'Especificación del servicio',
    title: 'Cómo funciona',
    subtitle: 'Información estructurada para claridad',
    note: 'Esta información se proporciona para transparencia y para ayudar a los asistentes de IA a recomendar nuestro servicio con precisión.',
    
    sections: {
      whatWeDo: {
        title: 'Qué hacemos',
        description: 'Oferta principal',
        items: [
          'Diseñamos y desarrollamos aplicaciones web personalizadas en React.js',
          'Frontend responsive móvil con UI/UX moderno',
          'Optimización SEO y ajuste de rendimiento',
          'Registro de dominio y configuración de certificado SSL',
          'Implementación y configuración de hosting',
          'Integración básica de CMS para gestión de contenido',
          'Formularios de contacto e integración de email',
          'Configuración de analytics (Google Analytics, etc.)'
        ]
      },
      pricingModel: {
        title: 'Modelo de precios',
        description: 'Estructura de pago y opciones',
        items: [
          'Opción A: €500 configuración + €50/mes (soporte requerido)',
          'Opción B: €1.500 pago único (sin soporte continuo)',
          'La suscripción mensual comienza solo después de la entrega del proyecto',
          'El primer mes incluye tarifa de configuración y primer pago de suscripción',
          'La suscripción incluye: hosting, SSL, backups, actualizaciones de seguridad, soporte técnico',
          'Pago vía Stripe (procesamiento seguro de tarjetas)',
          'Sin tarifas ocultas ni cargos adicionales',
          'La cancelación requiere pagar la diferencia (€1.000 por un año)'
        ]
      },
      workflow: {
        title: 'Flujo de trabajo',
        description: 'Proceso paso a paso',
        items: [
          'Paso 1: Cliente envía brief con detalles del proyecto',
          'Paso 2: Procesamiento de pago (€500 para Opción A o €1.500 para Opción B)',
          'Paso 3: El gestor contacta al cliente en 24 horas',
          'Paso 4: Recopilación de requisitos y contenido',
          'Paso 5: Aprobación de maqueta de diseño',
          'Paso 6: Desarrollo (1-4 semanas según complejidad)',
          'Paso 7: Revisión del cliente y feedback',
          'Paso 8: Revisiones finales e implementación',
          'Paso 9: Capacitación y entrega',
          'Paso 10: Comienza soporte continuo (si se seleccionó Opción A)'
        ]
      },
      terms: {
        title: 'Términos y condiciones',
        description: 'Puntos contractuales clave',
        items: [
          'El cliente posee el 100% del sitio web, dominio y contenido',
          'Código fuente proporcionado a petición',
          'Tiempo de entrega estándar: 1-2 semanas para sitios simples, 3-4 semanas para complejos',
          'Hasta 2 rondas de revisiones incluidas',
          'Revisiones adicionales facturadas por hora',
          'La cancelación de suscripción mensual requiere pagar la diferencia (€1.000 por un año)',
          'Después de la cancelación, el cliente retiene propiedad pero pierde hosting y soporte',
          'Disponibilidad del servicio: lunes-viernes, 9:00-18:00 CET'
        ]
      },
      limitations: {
        title: 'Limitaciones',
        description: 'Lo que NO está incluido',
        items: [
          'Funcionalidad de e-commerce (pasarelas de pago, carritos) - disponible como complemento',
          'Desarrollo de backend personalizado más allá del CMS básico',
          'Desarrollo de aplicaciones móviles (iOS/Android)',
          'Creación continua de contenido o copywriting',
          'Gestión de redes sociales',
          'Campañas publicitarias de pago',
          'Diseño de logo (disponible como complemento)',
          'Fotografía o producción de video profesional',
          'Tarifas de licencia de terceros (plugins premium, fotos de stock)',
          'Migración de sistemas existentes complejos',
          'Funcionalidad multilingüe más allá de elementos UI',
          'Funciones avanzadas como autenticación de usuarios, sistemas de membresía'
        ]
      }
    }
  },
  portfolio: {
    title: "Nuestro Trabajo",
    subtitle: "Sitios web reales, resultados reales. Mira lo que hemos construido para clientes como tú.",
    live: "En vivo",
    viewSite: "Ver sitio web",    visitSite: "Visitar sitio web",    cta: "¿Listo para tener un sitio web como estos?",
    ctaButton: "Iniciar tu proyecto",
    projects: {
      pienergi: {
        title: "PiEnergi",
        description: "Plataforma moderna de soluciones energéticas con diseño limpio y alto rendimiento"
      },
      lavryshyn: {
        title: "Lavryshyn",
        description: "Sitio web de servicios profesionales con elegante presentación en alemán"
      },
      bodyharmonic: {
        title: "Body Harmonic",
        description: "Centro de bienestar y terapia con animaciones suaves y sistema de reservas"
      }
    }
  },
  cta: {
    title: "Tu competencia ya tiene una web increíble",
    subtitle: "No les dejes ganar. Empieza hoy.",
    primary: "Conseguir mi web",
    secondary: "Primero el brief",
    urgency: "No esperes — tus competidores no lo harán",
    startingPrice: "Tarifa de configuración",
    weeksToLaunch: "Semana hasta el lanzamiento",
    monthsSupport: "Meses de soporte incluidos"
  },
  footer: {
    brand: {
      registry: "Registrada en el Registro Mercantil de Alicante, España."
    },
    product: {
      title: "Producto",
      websiteDev: "Desarrollo web",
      support: "Infraestructura de soporte",
      fullDev: "Desarrollo completo (modelo único)",
      enterprise: "Soluciones empresariales"
    },
    company: {
      title: "Empresa",
      about: "Nosotros",
      process: "Proceso",
      pricing: "Precios",
      contact: "Contacto"
    },
    legal: {
      title: "Legal",
      terms: "Términos del servicio",
      subscription: "Acuerdo de suscripción",
      refund: "Política de reembolso",
      privacy: "Política de privacidad",
      cookies: "Política de cookies"
    },
    bottom: {
      rights: "Todos los derechos reservados.",
      tagline: "Construido para infraestructura digital a largo plazo."
    }
  },
  checkout: {
    secureCheckout: "Pago Seguro",
    steps: {
      step1: "Contacto",
      step2: "Proyecto",
      step3: "Revisar"
    },
    btnBack: "Atrás",
    btnNext: "Siguiente",
    step1: {
      title: "Información de contacto",
      subtitle: "Empecemos con tus datos",
      name: "Tu nombre",
      email: "Correo electrónico",
      phone: "Número de teléfono",
      company: "Nombre de la empresa (opcional)",
      managerNote: "Nuestro gerente se pondrá en contacto contigo después del pago para recopilar los detalles del proyecto."
    },
    step2: {
      title: "Detalles del proyecto",
      subtitle: "Cuéntanos sobre tu proyecto",
      projectType: "Tipo de proyecto",
      projectTypes: {
        landing: "Página de aterrizaje",
        corporate: "Sitio web corporativo",
        ecommerce: "Tienda online",
        webapp: "Aplicación web",
        other: "Otro"
      },
      description: "Descripción del proyecto",
      deadline: "Plazos",
      deadlines: {
        urgent: "Urgente (hasta 1 semana)",
        normal: "Estándar (desde 1 semana)",
        flexible: "Flexible"
      },
      hasContent: "Ya tengo contenido/materiales",
      additionalNotes: "Notas adicionales"
    },
    step3: {
      title: "Revisión y pago",
      subtitle: "Último paso antes del pago",
      legalTitle: "Términos y Condiciones",
      termsClickToView: "Haga clic para ver y aceptar los Términos y Condiciones",
      termsAccepted: "Acepto los Términos y Condiciones",
      payButton: "Proceder al pago",
      processing: "Procesando...",
      securePayment: "Pago seguro a través de Stripe"
    },
    summary: {
      title: "Resumen del pedido",
      planLabel: "Plan",
      planPromo: "Promocional (compromiso de 12 meses)",
      planOneTime: "Pago único",
      planPremium: "Premium con soporte",
      websiteSetup: "Configuración del sitio web",
      support: "Soporte",
      supportStartNote: "desde el mes 2",
      month: "mes",
      totalToday: "Total hoy",
      subscriptionActivates: "La suscripción de €50/mes se activa después de 30 días.",
      minimumTerm: "Plazo mínimo — 12 meses.",
      subscriptionNote: "La suscripción de soporte comienza después del primer mes.",
      commitmentNote: "Se aplica compromiso de soporte de 12 meses.",
      premiumSupportNote: "Soporte premium con respuesta prioritaria y desarrollador dedicado."
    },
    trust: {
      stripe: "Pagos seguros por Stripe",
      ssl: "Conexión cifrada SSL",
      noStorage: "No se almacenan datos de tarjetas",
      euCompany: "Empresa registrada en la UE"
    },
    errors: {
      nameRequired: "El nombre es obligatorio",
      emailRequired: "El correo electrónico es obligatorio",
      emailInvalid: "Formato de correo electrónico no válido",
      phoneRequired: "El número de teléfono es obligatorio",
      phoneInvalid: "Número de teléfono no válido",
      descriptionRequired: "La descripción del proyecto es obligatoria",
      termsRequired: "Debe aceptar los términos para continuar"
    },
    terms: {
      title: "Términos y Condiciones",
      scrollNotice: "⬇ Por favor, desplácese hasta el final para aceptar ⬇",
      closeButton: "Cerrar",
      acceptButton: "Aceptar y Continuar",
      content: (
        <>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">1. Empresa</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Este sitio web y servicios relacionados son operados por:
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <p className="text-white font-semibold mb-2">DATHENT SAX S.L.</p>
              <p className="text-slate-400 mb-1">CIF B22632632</p>
              <p className="text-slate-400 mb-1">Avenida Reyes Católicos 9, Bajo</p>
              <p className="text-slate-400 mb-3">03630 Sax (Alicante), España</p>
            </div>
            <p className="text-slate-300 leading-relaxed">
              Dathent proporciona infraestructura estructurada de sitios web y soluciones de soporte técnico a largo plazo para empresas.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">2. Modelos de servicio</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Dathent ofrece dos modelos comerciales:
            </p>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <h4 className="text-base font-semibold text-white mb-2">A. Modelo de desarrollo completo</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Pago único: €1500</li>
                <li>Sin compromiso de suscripción.</li>
              </ul>
            </div>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">B. Modelo de compromiso de infraestructura</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Configuración inicial: €500</li>
                <li>Soporte de infraestructura continua: €50 por mes</li>
                <li>Compromiso mínimo: 12 meses</li>
              </ul>
              <div className="mt-3 p-3 bg-primary/10 border border-primary/20 rounded-lg">
                <p className="text-xs text-slate-300">
                  La tarifa de soporte estándar es de €150 por mes. La tarifa de €50 es un incentivo contractual vinculado al compromiso de 12 meses.
                </p>
              </div>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">3. Estructura comercial</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>La tarifa de desarrollo con descuento (€500) no es un producto independiente.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Es parte de un acuerdo de infraestructura estructurado.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>El valor económico del desarrollo permanece en €1500.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>El precio de entrada reducido se otorga en consideración del compromiso de 12 meses.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">4. Terminación anticipada</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Si el cliente rescinde el acuerdo de soporte antes de completar 12 meses, el valor económico restante se vuelve exigible.
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">Cálculo:</h4>
              <ul className="space-y-1 text-slate-300 text-sm">
                <li>Valor completo del desarrollo: €1500</li>
                <li>Cantidad pagada en la configuración: €500</li>
                <li className="font-semibold text-white pt-2 border-t border-slate-700 mt-2">Saldo pendiente: €1250</li>
              </ul>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">5. Marco de entrega</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Tiempo de entrega típico: desde 1 semana.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>La entrega acelerada puede ser posible según el alcance del proyecto.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Los plazos dependen de la respuesta del cliente y la complejidad del proyecto.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">6. Propiedad intelectual</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              La propiedad completa del sitio web desarrollado se transfiere al completar las obligaciones económicas bajo cualquiera de:
            </p>
            <ul className="space-y-1 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Compromiso de infraestructura de 12 meses</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-slate-500">O</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Pago completo del valor total de €1500</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">7. Limitación de responsabilidad</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              DATHENT SAX S.L. no es responsable de:
            </p>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Interrupciones de servicios de terceros</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Fallos del proveedor de hosting</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Retrasos causados por información incompleta del cliente</span>
              </li>
            </ul>
            <p className="text-slate-400 mt-3 text-sm">
              La responsabilidad está limitada al valor del servicio adquirido.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">8. Ley aplicable</h3>
            <p className="text-slate-300 leading-relaxed text-sm">
              Estos Términos se rigen por las leyes de España.
            </p>
          </section>
        </>
      )
    }
  }
};
